import styled, { css } from 'styled-components';
import { media } from '../../ui';
export const Title = styled.li.withConfig({
  displayName: "Style__Title",
  componentId: "sc-cfwx58-0"
})(["margin-bottom:10px;font-weight:500;line-height:1;"]);
export const RatingVotes = styled.span.withConfig({
  displayName: "Style__RatingVotes",
  componentId: "sc-cfwx58-1"
})(["display:block;margin-top:3px;font-size:12px;color:", ";"], ({
  theme: {
    color
  }
}) => color.grayText);
export const Option = styled.li.withConfig({
  displayName: "Style__Option",
  componentId: "sc-cfwx58-2"
})(["display:flex;margin-bottom:6px;line-height:1.18;.icon{margin-top:3px;margin-right:5px;}"]);
export const ListUnstyled = styled.ul.withConfig({
  displayName: "Style__ListUnstyled",
  componentId: "sc-cfwx58-3"
})(["padding-left:0;list-style:none;strong{font-weight:400;}"]);
export const PolicyLink = styled.span.withConfig({
  displayName: "Style__PolicyLink",
  componentId: "sc-cfwx58-4"
})(["color:", ";cursor:pointer;&:hover,&:focus{text-decoration:underline;}"], ({
  theme: {
    color
  }
}) => color.primary);
export const RatingAttention = styled.p.withConfig({
  displayName: "Style__RatingAttention",
  componentId: "sc-cfwx58-5"
})(["color:", ";", ""], ({
  theme: {
    color
  }
}) => color.grayText, media.sm`
    font-size: ${({
  theme: {
    fontSize
  }
}) => fontSize.sm}px;
  `);
export const RatingItem = styled.li.withConfig({
  displayName: "Style__RatingItem",
  componentId: "sc-cfwx58-6"
})(["display:flex;align-items:flex-end;justify-content:space-between;margin-bottom:5px;font-size:", "px;"], ({
  theme: {
    fontSize
  }
}) => fontSize.default);
export const RatingItemDivider = styled.div.withConfig({
  displayName: "Style__RatingItemDivider",
  componentId: "sc-cfwx58-7"
})(["flex:1;margin:0 4px 1px;border-bottom:1px solid ", ";"], ({
  theme: {
    color
  }
}) => color.gray);
export const SegmentPointsDevider = styled.div.withConfig({
  displayName: "Style__SegmentPointsDevider",
  componentId: "sc-cfwx58-8"
})(["width:100%;padding-top:10px;padding-bottom:10px;margin:16px 0;font-size:12px;border-top:", ";border-bottom:", ";", ""], ({
  theme: {
    color
  }
}) => `1px solid ${color.gray}`, ({
  theme: {
    color
  }
}) => `1px solid ${color.gray}`, ({
  theme: {
    color
  },
  isDashed
}) => isDashed && css(["border-bottom:1px dashed ", ";background-color:transparent;"], color.gray));
export const CriticalInfo = styled.div.withConfig({
  displayName: "Style__CriticalInfo",
  componentId: "sc-cfwx58-9"
})(["display:flex;padding:15px;margin:0 25px 25px 25px;border:solid 1px ", ";border-radius:6px;", " ", ""], ({
  theme: {
    color
  }
}) => color.orange, ({
  skipMargins = false
}) => skipMargins && css(["margin:0;"]), media.sm`
    margin-left: 15px;
    margin-right: 15px;
  `);
export const CriticalIcon = styled.div.withConfig({
  displayName: "Style__CriticalIcon",
  componentId: "sc-cfwx58-10"
})(["align-self:start;margin-right:15px;font-size:120%;.icon-info{color:", ";}"], ({
  theme: {
    color
  }
}) => color.orange);
export const CriticalText = styled.div.withConfig({
  displayName: "Style__CriticalText",
  componentId: "sc-cfwx58-11"
})(["font-size:", "px;"], ({
  theme: {
    fontSize
  }
}) => fontSize.default);
export const Details = styled.div.withConfig({
  displayName: "Style__Details",
  componentId: "sc-cfwx58-12"
})([""]);
export const DetailsContent = styled.div.withConfig({
  displayName: "Style__DetailsContent",
  componentId: "sc-cfwx58-13"
})(["display:flex;margin:0 -30px;> div{flex-basis:50%;margin:0 30px;", "}", ""], media.sm`
      flex-basis: 100%;
    `, media.sm`
    flex-direction: column;
  `);
// hack: hide title
export const RefundWrapper = styled.div.withConfig({
  displayName: "Style__RefundWrapper",
  componentId: "sc-cfwx58-14"
})([".h3.m-b-2{display:none;}"]);